export default __webpack_public_path__ + "static/media/lightrain.f4d77a57.mp4";